import { jsx as _jsx } from "react/jsx-runtime";
import useFormDuuf from '../useFormDuuf';
var errorMessages = {
  nl: {
    required: 'Is verplicht',
    email: 'E-mailadres niet juist',
    consent: 'U dient akkoord te gaan met de voorwaarden',
    default: 'Er ging iets mis'
  },
  en: {
    required: 'Is required',
    email: 'Is incorrect',
    consent: 'You must agree to the terms',
    default: 'Something went wrong'
  }
};
var Error = function Error(_ref) {
  var formik = _ref.formik,
    hasError = _ref.hasError,
    fieldId = _ref.fieldId,
    data = _ref.data;
  var formduuf = useFormDuuf();
  if (!hasError) {
    return null;
  }
  var errors = errorMessages[formduuf.language];
  return _jsx("div", {
    className: "form-duuf-error form-duuf-error-".concat(data.type.toLowerCase()),
    children: errors[formik.errors[fieldId]] || formik.errors[fieldId]
  });
};
export default Error;